'use strict';

import '@babel/polyfill';
// import Swiper from 'swiper';
import { ua } from './view/_ua';
import { loading } from './view/_loading';
import { header } from './view/_header';
// import { modal } from './view/_modal';
import { faq } from './view/_faq';
import { height } from './view/_height';
import { smoothScroll } from './view/_smoothScroll';
import { scroll } from './view/_scroll';
// import { filter } from './view/_filter';
// import { accordion } from './view/_accordion';
import { slider } from './view/_slider';
// import { data } from './view/_data';
import { map } from './view/_map';
// import { kv } from './view/_kv';
